// import packages
import React, {useState, useEffect, useRef} from "react";
import {connect} from "react-redux";

// Import assets
import "./buildings.scss"
import {
    BuildingsFirstImage,
    BuildingsSecondImage,
    BuildingsFirstSelectSVG,
    BuildingsSecondSelectSVG,
    SwipeIcon, HeaderParkingIcon, HeaderMapIcon
} from "../../assets/images";
// Import Components

// Import utils
import {getPropsFromState} from "../../redux/mapStateToProps";
import {
    GetAbout,
    GetBuildingByIdOrSlug,
    GetBuildings, GetGraphics,
    GetProjectByIdOrSlug
} from "../../redux/actions";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";
import HeaderWrapper from "../../components/HeaderWrapper/HeaderWrapper";
import {generateFileMediaUrl} from "../../utils/generateMediaUrl";
import {Link, useNavigate} from "react-router-dom";
import Subscription from "../../components/subscription/Subscription";
import {AREA_TYPES, BUILDINGS_SLUG} from "../../constants/constants";
import Slider from "react-slick";
import MouseTracker from "../../components/MouseTracker";
import MapModal from "../../components/modal/mapModal/MapModal";
import LinkBtn from "../../components/buttons/LinkBtn";

// import HousesFilter from "../housesFilter/HousesFilter";


function Buildings(props) {
    const [isBuildingInfoVisible, setBuildingInfoVisible] = useState(false)
    const [buildingIndex, setBuildingIndex] = useState(0)
    const [floor, setFloor] = useState({})
    const [visible, setVisible] = useState(false)
    const navigate = useNavigate();
    const {about, staticTexts, graphicsList, buildingById,areaData} = props

    let sliderRef = useRef(null);
    const settings = {
        dots: false,
        arrows: false,
        speed: 500,
        ref: slider => (sliderRef = slider),
        variableWidth: true,
        infinite: true,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        getBuildingsData()
        props.GetAbout()
    }, [])

    useEffect(() => {
        buildingById?.id && props.GetGraphics(buildingById?.id)
    }, [buildingById?.id])

    async function getBuildingsData() {
        // const buildingData = !buildingById ? await props.GetBuildingByIdOrSlug(BUILDINGS_SLUG) : buildingById;
        const buildingData = await props.GetBuildingByIdOrSlug(BUILDINGS_SLUG);

        buildingData?.floors?.slice(1).map(item => {
            // console.log(`${buildingData?.slug}_${item?.number}`, document.getElementById(`${buildingData?.slug}_${item?.number}`))
            document.getElementById(`${buildingData?.slug}_${item?.number}`)?.addEventListener("mouseenter", onMouseEnter.bind(null, item));
            document.getElementById(`${buildingData?.slug}_${item?.number}`)?.addEventListener("mouseleave", onMouseLeave)
            document.getElementById(`${buildingData?.slug}_${item?.number}`)?.addEventListener("click", onClick.bind(null, item))
            if (item?.inactive) {
                document.getElementById(`${buildingData?.slug}_${item?.number}`).classList.add("inactive")
            }
        })

    }

    function onMouseEnter(floor) {
        setFloor(floor);
        setBuildingInfoVisible(true);
    }

    function onMouseLeave() {
        setBuildingInfoVisible(false)
        setFloor({})
    }

    function onClick(floor) {
        if (!floor.inactive) {
            navigate(getUrlWithLocal(`/floor/${floor?.number}`))
        }
    }

    const buildingsImages = [BuildingsFirstImage, BuildingsSecondImage]
    const buildingsSvgImages = [BuildingsFirstSelectSVG, BuildingsSecondSelectSVG]
    const BuildingsSelectSVG = buildingsSvgImages[buildingIndex]

    const headerRightPartJsx = <div className={'header-parking-map-wrapper'}>
        {/*<div className={'header-button'} onClick={() => navigate(getUrlWithLocal('/floor/-1'), {*/}
        {/*    state: {*/}
        {/*        type: AREA_TYPES.PARKING.key*/}
        {/*    }*/}
        {/*})}>*/}
        {/*    <HeaderParkingIcon/>*/}
        {/*</div>*/}
        <div className={'header-button'} onClick={() => setVisible(true)}>
            <HeaderMapIcon/>
        </div>
    </div>

    function closeModal() {
        setVisible(!visible)
    }

    return <div className={'BuildingsWrapper'}>
        <HeaderWrapper addressFirst={staticTexts?.rout_item_buildings}
                        rightPartJsx={headerRightPartJsx}
                        withBg={false}/>
        <div className={'TopContent'}>
            <div className="ImageWrapper">
                <img src={buildingsImages[buildingIndex]} alt={"building"}/>
                <div className={'svg-wrapper'}>
                    <BuildingsSelectSVG/>
                    <MouseTracker
                        visible={isBuildingInfoVisible}
                        offsetX={15}
                        offsetY={10}
                    >
                        <div className={'tooltip-wrapper'}>
                            <div
                                className={`tooltip-left-part ${floor.inactive ? "inactive-floor" : ""} ${!floor?.housesCount ? "only-floor" : ""}`}>
                                <span className={'building-number'}>{floor.number}</span>
                                <span className={'building-text'}>{staticTexts?.mouse_info_floor}</span>
                            </div>
                            <div className={'tooltip-right-part'}>
                                <span className={'houses-count'}>
                                    {staticTexts?.mouse_info_is_available.replace('%', floor?.availableCount)}
                                </span>
                            </div>
                        </div>
                    </MouseTracker>
                </div>
                <div className="help-swipe load">
                    <div className="center">
                        <div className="aline">
                            <img alt="" src={SwipeIcon}/>
                        </div>
                    </div>
                </div>
                <div className={'info-block'}>
                    <div className="change-building">
                        <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112"
                             viewBox="0 0 112 112" fill="none">
                            <g id="project">
                                <path className={`bottom-path ${buildingIndex === 1 ? 'active' : ''}`}
                                      id="0" onClick={() => setBuildingIndex(1)}
                                      d="M39.0406 73.8969L58.0276 61.8812L85.2898 77.6839L75.3214 94.9496L39.0406 73.8969Z"
                                      fill="#FF2B0F" fill-opacity="0.56" stroke="#FF2B0F"/>
                                <path className={`top-path ${buildingIndex === 0 ? 'active' : ''}`}
                                      id="1" onClick={() => setBuildingIndex(0)}
                                      d="M36.5511 26.9593L55.2771 25.7492L57.4996 61.034L38.5291 73.0419L36.5511 26.9593Z"
                                      fill="#FF2B0F" fill-opacity="0.45" stroke="#FF2B0F"/>
                                <path id="Vector"
                                      d="M5.28679 92.3097C5.50259 91.2543 6.13278 90.4361 6.78522 89.7826C7.4595 89.1392 8.20053 88.6295 8.96844 88.1972C10.5051 87.3325 12.1139 86.7251 13.7337 86.19C15.3484 85.6694 16.993 85.2329 18.6598 84.8825C21.9766 84.1722 25.327 83.6883 28.6824 83.3745C25.3933 84.078 22.1328 84.8598 18.9524 85.8398C17.3604 86.3338 15.796 86.8693 14.2812 87.4815C12.7719 88.1041 11.2961 88.8042 10.0134 89.6638C9.37191 90.0961 8.77489 90.5593 8.30508 91.0741C7.85164 91.5822 7.52542 92.1341 7.47042 92.6489C7.41542 93.1637 7.56446 93.6473 7.91798 94.1413C8.2887 94.6303 8.83031 95.0834 9.42188 95.5C10.6546 96.3084 12.0976 96.967 13.5901 97.5232C15.0827 98.0795 16.655 98.5423 18.2341 98.9488C24.6028 100.508 31.2255 101.414 37.8595 101.949C39.9548 102.124 42.0541 102.267 44.1572 102.376V105.871C41.9351 105.737 39.7145 105.557 37.4955 105.331C34.1123 104.975 30.7288 104.522 27.3675 103.936C25.6881 103.648 24.012 103.313 22.3423 102.942C20.6784 102.552 19.02 102.119 17.378 101.635C15.7305 101.136 14.0994 100.58 12.4964 99.9057C10.8934 99.2318 9.31775 98.4489 7.86382 97.3477C7.15007 96.7763 6.45397 96.143 5.90649 95.3042C5.78515 95.083 5.66884 94.8566 5.55255 94.6299C5.44758 94.3985 5.38712 94.1359 5.30945 93.8873C5.20407 93.3748 5.17091 92.8241 5.28679 92.3097Z"
                                      fill="white"/>
                                <path id="Vector_2"
                                      d="M63.7325 102.582C68.4499 102.445 73.1522 102.146 77.8394 101.683C84.4512 101.045 91.0688 100.036 97.3048 98.2093C98.8469 97.7355 100.368 97.1898 101.761 96.516C102.468 96.1864 103.11 95.8003 103.718 95.3988C104.293 94.9767 104.818 94.524 105.161 94.0452C105.504 93.5664 105.647 93.0981 105.559 92.6095C105.498 92.115 105.161 91.5748 104.696 91.0702C103.751 90.0617 102.352 89.2483 100.931 88.538C98.0509 87.1125 94.8559 86.1146 91.6528 85.2335C88.4301 84.3587 85.1452 83.6485 81.8456 83C85.2202 83.246 88.5775 83.6669 91.9018 84.261C93.5714 84.5542 95.2299 84.9178 96.8774 85.3519C98.5195 85.7897 100.156 86.294 101.759 86.9424C103.346 87.6167 104.938 88.3836 106.32 89.6603C106.989 90.3033 107.641 91.1167 107.89 92.1768C108.172 93.2322 107.884 94.4048 107.344 95.2495C106.808 96.1145 106.112 96.7739 105.387 97.3497C104.673 97.8863 103.913 98.3682 103.115 98.7909C101.556 99.6297 99.9419 100.283 98.3108 100.86C95.0549 102.013 91.7267 102.831 88.3709 103.49C85.015 104.149 81.6483 104.669 78.2651 105.075C73.4331 105.633 68.5842 105.968 63.7304 106.142V111.684L50.0781 104.345L63.7325 97.0057V102.582Z"
                                      fill="white"/>
                            </g>
                        </svg>
                    </div>
                    <Link className={'builds-info'} to={
                        {
                            pathname: getUrlWithLocal('/filter'),
                            state: 'fromBuildings'
                        }
                    }>
                        <div className={'builds'}>
                            <h3>{areaData?.count}</h3>
                            <span>{staticTexts?.house_available_apartments} > </span>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
        {/*<div className="slider-wrapper">*/}
        {/*    <div className="slider-title">{staticTexts?.house_slider_title}</div>*/}

        {/*    /!* <div className="slider-content">*/}
        {/*        {*/}
        {/*            list?.length && list.map((item, index) =>{*/}
        {/*                return <div className={`slider-item ${item.active ? 'active' : ''}`} key={index}>*/}
        {/*                    <div className="date">{item?.date}</div>*/}
        {/*                    <div className="text">{item?.text}</div>*/}
        {/*                </div>*/}
        {/*            })*/}
        {/*        }*/}
        {/*    </div>*!/*/}
        {/*    <div className="slider-wrap">*/}
        {/*        {<Slider{...settings} className="slider-content">*/}
        {/*            {graphicsList?.length && graphicsList?.map((item, index) =>*/}
        {/*                    // <div style={{width: 244}}>*/}
        {/*                    <div style={{width: 244}}*/}
        {/*                         className={`slider-item ${item.checked ? 'active' : ''}`}*/}
        {/*                         key={index}>*/}
        {/*                        <div className="date">{item?.title}</div>*/}
        {/*                        <div className="text">{item?.description}</div>*/}
        {/*                    </div>*/}
        {/*                // </div>*/}
        {/*            )}*/}
        {/*        </Slider>}*/}
        {/*        <div className="next-button" onClick={(e) => {*/}
        {/*            e.stopPropagation()*/}
        {/*            sliderRef.slickNext()*/}
        {/*        }}> >*/}
        {/*        </div>*/}
        {/*    </div>*/}
        {/*    <div className="gradient"/>*/}
        {/*</div>*/}
        <div className={'DescriptionContent'}>
            {/*<div className={'background-block'}></div>*/}
            {/*<div className={'background_bottom_block'}></div>*/}
            {
                !!about?.blocks?.length && about?.blocks?.map((item, index) => {
                    return <div key={item?.id} className={`${(index + 1) % 2 === 0 ? 'RightSide' : 'LeftSide'}`}>
                        <div className={'text-wrapper'}>
                            <div
                                className={`${(index + 1) % 2 === 0 ? 'RightSideTitle' : 'LeftSideTitle'}`}>{item?.title}</div>
                            <div className={'buildings-text'} dangerouslySetInnerHTML={{__html: item?.description}}>
                            </div>
                            <LinkBtn link={'/about'} staticTexts={staticTexts}/>
                        </div>
                        <div className={`${(index + 1) % 2 === 0 ? 'rightImg-wrapper' : 'img_wrapper'}`}>
                            <div className={`${(index + 1) % 2 === 0 ? 'rightImg-block' : 'leftImg-block'}`}>
                                <img className={'buildings-images'}
                                     src={generateFileMediaUrl(item?.mediaMain?.path)} alt=""/>
                            </div>
                        </div>
                    </div>
                })
            }
            {/* <div className={'LeftSide'}>
                <div className={'text_wrapper'}>
                    <div className={'LeftSideTitle'}>{about?.blocks[1]?.title}</div>
                    <div className={'buildings-text'} dangerouslySetInnerHTML={{__html: about?.blocks[1]?.description}}>
                    </div>
                </div>
                <div className={'img_wrapper'}>
                    <div className={'leftImg-block'}>
                        <img className={'buildings-images'}
                             src={generateFileMediaUrl(about?.blocks[1]?.mediaMain?.path)} alt=""/>
                    </div>
                </div>
            </div>
            <div className={'RightSide'}>
                <div className={'text-wrapper'}>
                    <div className={'RightSideTitle'}>{about?.blocks[2]?.title}</div>
                    <div className={'buildings-text'} dangerouslySetInnerHTML={{__html: about?.blocks[2]?.description}}>
                    </div>
                </div>
                <div className={'rightImg-wrapper'}>
                    <div className={'rightImg-block'}>
                        <img className={'buildings-images'}
                             src={generateFileMediaUrl(about?.blocks[2]?.mediaMain?.path)} alt=""/>
                    </div>
                </div>
            </div>
            <div className={'LeftSide'}>
                <div className={'text_wrapper'}>
                    <div className={'LeftSideTitle'}>{about?.blocks[3]?.title}</div>
                    <div className={'buildings-text'} dangerouslySetInnerHTML={{__html: about?.blocks[3]?.description}}>
                    </div>
                </div>
                <div className={'img_wrapper'}>
                    <div className={'leftImg-block'}>
                        <img className={'buildings-images'}
                             src={generateFileMediaUrl(about?.blocks[3]?.mediaMain?.path)} alt=""/>
                    </div>
                </div>
            </div>*/}
        </div>
        {/*<Subscription/>*/}
        {
            visible && <MapModal closeModal={closeModal}
                                 visible={visible}/>
        }
    </div>

}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'buildings',
    'contact',
    'about',
    'areas',
    'areaData',
    'projects',
    'projectById',
    'buildingById',
    'graphicsList',
]);

const mapDispatchToProps = {
    GetBuildingByIdOrSlug,
    GetBuildings,
    GetAbout,
    GetProjectByIdOrSlug,
    GetGraphics
};

export default connect(mapStateToProps, mapDispatchToProps)(Buildings);

